/**
 * The sidebar tree's insertion line: where a reorder drop will land, drawn
 * at the boundary above or below the hovered row and starting at that row's
 * indent (so it shows the level the item lands in), with a ring at its start.
 * A picture of the drag only: `aria-hidden` and never hit by the pointer.
 */

import { Box } from '@chakra-ui/react';

import { TREE_INDENT_PX } from './FolderTreeRow';
import type { ReorderPosition } from './treeReorder';

interface TreeDropLineProps {
  /** The row boundary, in px from the top of the tree. */
  readonly top: number;
  readonly level: number;
  readonly position: ReorderPosition;
}

export function TreeDropLine({ top, level, position }: TreeDropLineProps) {
  return (
    <Box
      aria-hidden
      data-testid="tree-drop-line"
      data-position={position}
      position="absolute"
      top={`${top - 1}px`}
      left={`${8 + (level - 1) * TREE_INDENT_PX}px`}
      right={1}
      h="2px"
      borderRadius="full"
      bg="border.focus"
      pointerEvents="none"
      zIndex={1}
      _before={{
        content: '""',
        position: 'absolute',
        left: '-6px',
        top: '-3px',
        boxSize: '8px',
        borderRadius: 'full',
        border: '2px solid',
        borderColor: 'border.focus',
        bg: 'sidebar.bg',
      }}
    />
  );
}
